import { FamilyTreeChart, JsonGedcomData } from '@/familyTree/index';
import { Text, Card, styled } from '@/theme/index';

const FamilyTreeBanner = styled(Text)(({ theme }) => ({
  textDecoration: 'underline',
  color: 'white',
  margin: 'auto',
  top: '20px',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  position: 'absolute',
  zIndex: 100,
  textAlign: 'center',
  backgroundColor: theme.palette.primary.main,
  padding: 1,
  width: '100%',
}));

interface FamilyTreePreviewProps {
  familyTreeData: JsonGedcomData;
  imgFamilyTreePlaceholder?: string;
  imgFamilyTreeAddRelative?: string;
  imgFamilyTreeDeceased?: string;
  imgFamilyTreePetIcon?: string;
  imgFamilyTreeOriginalMember?: string;
  imgFamilyTreeBackground?: string;
  isHovered: boolean;
  setHovered: (hovered: boolean) => void;
  handleClick: () => void;
}

const FamilyTreePreview = ({
  familyTreeData,
  imgFamilyTreePlaceholder,
  imgFamilyTreeAddRelative,
  imgFamilyTreeDeceased,
  imgFamilyTreePetIcon,
  imgFamilyTreeOriginalMember,
  imgFamilyTreeBackground,
  isHovered,
  setHovered,
  handleClick,
}: FamilyTreePreviewProps) => {
  return (
    <Card
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => handleClick()}
      data-cy="family-tree-preview-card"
      sx={{
        position: 'relative',
        padding: 0,
        borderRadius: 0.5,
        cursor: 'pointer',
        height: '348px',
        backgroundImage: imgFamilyTreeBackground
          ? `url(${imgFamilyTreeBackground})`
          : 'none',
        backgroundSize: 'cover',
      }}
    >
      {isHovered && (
        <FamilyTreeBanner variant="h2" sx={{}} onClick={() => handleClick()}>
          See Full Family Tree
        </FamilyTreeBanner>
      )}
      <FamilyTreeChart
        isPreview
        data={familyTreeData}
        imgFamilyTreePlaceholder={imgFamilyTreePlaceholder}
        imgFamilyTreeAddRelative={imgFamilyTreeAddRelative}
        imgFamilyTreeDeceased={imgFamilyTreeDeceased}
        imgFamilyTreeOriginalMember={imgFamilyTreeOriginalMember}
        imgFamilyTreePetIcon={imgFamilyTreePetIcon}
        handleNodeClick={() => {}}
        softDestroyMemberFromNode={() => {}}
        patchMemberFromDrag={() => {}}
        onSelection={() => {}}
      />
    </Card>
  );
};

export default FamilyTreePreview;
